(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/jackpots/assets/javascripts/jackpots.js') >= 0) return;  svs.modules.push('/widgets/jackpots/assets/javascripts/jackpots.js'); "use strict";

(function (svs) {
  'use strict';

  svs.widget = svs.widget || {};
  svs.widget.jackpots = svs.widget.jackpots || {};

  svs.widget.jackpots.init = function (options) {
    var $el = options.$el;
    new svs.components.ContentReveal({
      el: $el.find('.js-content-reveal-jackpots')
    });
    $el.on('click', '.jackpot-item-link', jackpotLink);
  };

  function trackClick(el, callback) {
    var $el = $(el),
        track = $el.data('track'),
        areaName = $el.data('areaName') || 'unknown';

    if (track) {
      svs.components.analytics.trackPromoClick({
        id: track,
        name: track,
        position: areaName
      }, callback);
    }
  }

  function jackpotLink(e) {
    e.preventDefault();
    var url = $(this).attr('href');
    trackClick(this, function () {
      window.location.href = url;
    });
  }
})(svs);
 })(window);